import React, { forwardRef, isValidElement, cloneElement, ForwardedRef } from "react";
import classNames from "classnames";
import { ButtonLinkType } from "./types";

export const SVVButtonLink = forwardRef<HTMLAnchorElement, ButtonLinkType>(function ButtonInternal(
  props: ButtonLinkType,
  ref: ForwardedRef<HTMLAnchorElement>,
) {
  const {
    children,
    small,
    color,
    icon,
    iconPlacement,
    looksLikeLink,
    href,
    className,
    ...restProps
  } = props;

  const buttonCss = classNames(
    "svv-button",
    {
      "svv-button--small": small,
      "svv-button--secondary": color === "secondary",
      "svv-button--icon": !!icon,
      "svv-button--icon-right": iconPlacement === "right",
    },
    props.className,
  );

  return (
    <a
      ref={ref}
      href={href}
      {...restProps}
      className={looksLikeLink ? `svv-button--looks-like-link ${className}` : buttonCss}
    >
      {icon && isValidElement(icon) && cloneElement(icon, { "aria-hidden": true })}
      {children}
    </a>
  );
});
